// extracted by mini-css-extract-plugin
module.exports = {"product-support-tutorial":"Tutorial_product-support-tutorial__XvPnq"};